import Get from '../Get';
import { Grid, Space } from '../../Layout';
import { Texts, Button, Media } from '../../Object';
import { SetDate } from '../SetDate.js';
import { SetImg } from '../SetImg.js';
import { replaceTag } from '../replaceTag';
import { useDocumentLoadCompleted } from '../../Hooks';
import { Link } from 'react-router-dom';

const WorksList = (props) => {
  // Getオプション
  const args = {
    postType: "voice",
    perPage: props.perPage ? props.perPage : 6,
    page: props.page ? props.page : 1,
  };

  // post情報の取得
  const posts = Get(args);

  // 個別のエレメント情報
  const Item = (props) => {
    let post = {
      title: props.post.title.rendered, // タイトル
      id: props.post.id, // post id
      body: replaceTag(props.post.content.rendered),
    };

    const gridProps = {
      wrap: {
        dir: "row",
        layout: "100%",
        size: ["100%", "100%"],
        gap: "19px",
      },
      body: {
        dir: "row",
        layout: "100%",
        size: "100%",
        gap: "27px",
      },
      bottom: {
        dir: "column",
        layout: "1fr 16px",
        gap: '12px',
      }
    };
    return (
      <>

        <Link to={`/post/voice/${post.id}`}>
          <div className="p-voice__wrap--box p-post__hover">
            <Grid {...gridProps.wrap}>
              <Media src="voice/icon-family" alt="family" class="p-voice__img--family"></Media>
              <Grid {...gridProps.body}>
                <p className="c-text__normal c-text--med c-text__line-cut--2">
                  {post.body}
                </p>
                <Grid {...gridProps.bottom}>
                  <p className="c-text__min">{post.title}</p>
                  <Media src="common/icon-list-arrow" alt=">"></Media>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Link>
      </>
    );
  };

  const Loading = (props) => {
    return (
      <>
        <p>Loading...</p>
      </>
    );
  };

  let items = [];
  if (posts) {
    // post情報取得後
    items = posts.map((post, key) => {
      return <Item key={key} post={post} />;
    });
  } else {
    // post情報取得中
    items.push(<Loading></Loading>);
  }

  return (
    // 全体のエレメント
    <>
      {items}
    </>
  );
};

export default WorksList;